import { render, staticRenderFns } from "./Tweakwise.vue?vue&type=template&id=e5e38fec&"
import script from "./Tweakwise.vue?vue&type=script&lang=ts&"
export * from "./Tweakwise.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e5e38fec')) {
      api.createRecord('e5e38fec', component.options)
    } else {
      api.reload('e5e38fec', component.options)
    }
    module.hot.accept("./Tweakwise.vue?vue&type=template&id=e5e38fec&", function () {
      api.rerender('e5e38fec', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "module/Deals/view/vue/Tweakwise.vue"
export default component.exports